import axios from 'axios';
export function LoginApi(data) {
    return axios.post(process.env.REACT_APP_API + "/api/auth/login_client.php", data);
}

export function RegisterApi(data) {
    return axios.post(process.env.REACT_APP_API + "/api/auth/register.php", data);
}